import React, { useEffect, useState } from "react";
import "./Admin.css";
import axios from "axios";
import { baseurl } from "./CoocpeatHome";
import { useNavigate } from "react-router-dom";

function AdminDashBoard() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("admin_token");

        if (token) {
            navigate("/admin/home");
        }
    }, [navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post(baseurl + "admin/AdminLogin", {
                email: username,
                password: password,
            });
            console.log("Admin login response:", response.data);
            const token = response.data.token;
            console.log("Admin logged in, token:", token);
            if (token) {
                localStorage.setItem("admin_token", token);
                navigate("/admin/home");
            }
        } catch (error) {
            alert("Invalid Admin Credentials");
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="admin-login-container">
            <div className="admin-login-card">
                <h2 className="login-title">Admin Login</h2>

                <form onSubmit={handleLogin}>
                    <div className="input-group">
                        <label>Username</label>
                        <input
                            type="text"
                            placeholder="Enter admin username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>

                    <div className="input-group">
                        <label>Password</label>
                        <input
                            type="password"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button className="login-btn-modern" disabled={loading}>
                        {loading ? "Logging in..." : "Log In"}
                    </button>

                    {loading && <div className="simple-spinner"></div>}

                </form>
            </div>
        </div>
    );
}

export default AdminDashBoard;
